import { mathUtils } from '../../lib/mathUtils-sidecar'
import { common } from '../../main/common-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import { voyageUiGraphicsUtils } from './voyageUiGraphicsUtils-sidecar'

interface IVoyageUiPause extends IVoyageUiCanvas {}
let _obj: IVoyageUiPause | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

const create = () => {
  let tw = 0
  let th = 0
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IVoyageUiPause = voyageUiCanvas.assign<IVoyageUiPause>(canvas, {})
  voyageUiCanvas.setOpen(obj, true)
  return obj
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)

  let gb = voyageCamera.getGameBounds()

  let alpha = mathUtils.sineLike(common.getElapsedTime(), 4, 0.25, 1)
  let color = voyageColors.red

  let bannerWidth = 1280 - 35
  let x = (gb.width - bannerWidth) / 2
  let y = 60

  if (voyageGameManager.get().isPaused) {
    renderBanner(obj, x, y, color, alpha, 'Paused - Press Space')
  }

  voyageUiCanvas.render(obj)
}

export const update = () => {
  let obj = get()
  voyageUiCanvas.update(obj)
  render()
}

export function renderBanner(
  obj: IVoyageUiCanvas,
  x: number,
  y: number,
  color: number,
  alpha: number,
  text: string,
) {
  let w = 200
  let h = 40
  let bevel = h / 2
  let padding = 20
  let g = obj.graphics

  w = 200
  g.fillStyle(color, alpha)
  voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel)
  g.fill()

  x += w + padding

  w = 60
  g.fillStyle(color, alpha)
  voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel)
  g.fill()

  x += w + padding

  g.fillStyle(color, alpha)
  voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel)
  g.fill()

  x += w + padding

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(echoFonts.getData().font6, x, y, obj.layer)
    stevieTexts2.setWrapWidth(_text, 500)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 6)

    let colorText = 0xffffff
    stevieTexts2.setTint(_text, colorText)
    stevieTexts2.setAlpha(_text, alpha)
    obj.texts.push(_text)
  }
  addText(text, x + 20, y + 20)

  x += 465 + padding

  w = 60
  g.fillStyle(color, alpha)
  voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel)
  g.fill()

  x += w + padding

  g.fillStyle(color, alpha)
  voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel)
  g.fill()

  x += w + padding

  w = 200
  g.fillStyle(color, alpha)
  voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel)
  g.fill()

  x += w + padding
}
